// removed by extract-text-webpack-plugin
module.exports = {"addButton":"style__addButton___3zsn0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AddButton/style.scss
// module id = 2214
// module chunks = 0